import n from "react";
import z from "react-select";
import E from "classnames";
import { tint as s } from "../../../../../../common/libs/tint.js";
import i from "./selector.module.scss.js";
function R({
  onChange: r,
  options: p,
  textColor: o = "#FFF",
  labelColor: d = o,
  noPadded: c,
  backgroundColor: a = "#242323",
  borderColor: m,
  placeholder: u,
  label: l,
  className: f,
  isDisabled: b,
  required: S,
  value: y,
  defaultValue: x,
  menuPlacement: g = "auto",
  menuPosition: v,
  menuIsOpen: F,
  menuPortalTarget: _,
  testId: w = "selector"
}) {
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: f,
      "data-testid": w
    },
    l && /* @__PURE__ */ n.createElement(
      "div",
      {
        className: E({
          [i.label]: !0,
          [i.label__noPadded]: c
        }),
        style: {
          color: d
        }
      },
      l
    ),
    /* @__PURE__ */ n.createElement(
      z,
      {
        value: y,
        menuPortalTarget: _,
        menuIsOpen: F,
        defaultValue: x,
        isDisabled: b,
        required: S,
        onChange: (...e) => r == null ? void 0 : r(...e),
        menuPlacement: g,
        menuPosition: v,
        placeholder: u,
        isSearchable: !1,
        className: i.selector,
        options: p ?? [],
        styles: {
          container: (e, t) => ({
            ...e,
            ...t.isDisabled ? {
              opacity: ".5"
            } : {},
            outline: "none",
            fontSize: "13px"
          }),
          control: (e, t) => ({
            ...e,
            border: 0,
            boxShadow: "none",
            borderRadius: "none",
            background: "transparent",
            borderBottom: "1px solid",
            cursor: "pointer",
            borderColor: `${m || s(-0.5, o)} !important`,
            color: o
          }),
          indicatorSeparator: (e, t) => ({
            ...e,
            display: "none"
          }),
          singleValue: (e, t) => ({
            ...e,
            color: `${o}`
          }),
          valueContainer: (e, t) => ({
            ...e,
            padding: c ? "5px 0px" : "5px 10px"
          }),
          indicatorsContainer: (e, t) => ({
            ...e
          }),
          dropdownIndicator: (e, t) => ({
            ...e,
            transition: "all .2s ease",
            transform: t.isFocused ? "rotate(180deg)" : "",
            color: `${o} !important`
          }),
          placeholder: (e, t) => ({
            ...e,
            color: o,
            opacity: ".8"
          }),
          menu: (e, t) => ({
            ...e,
            backgroundColor: a,
            padding: "0",
            color: o,
            width: "99%",
            left: "0.5%"
          }),
          option: (e, t) => ({
            ...e,
            padding: "13px 20px",
            "&:hover": {
              backgroundColor: s(0.02, a),
              cursor: "pointer"
            },
            backgroundColor: t.isSelected ? s(0.02, a) : "transparent",
            "&:focus": {
              backgroundColor: "transparent"
            },
            color: o
          }),
          menuPortal: (e, t) => ({
            ...e,
            zIndex: "2000",
            fontSize: "13px"
          })
        }
      }
    )
  );
}
export {
  R as Selector
};
//# sourceMappingURL=Selector.js.map
